import { Fragment, useContext, useRef } from "react";
import FramePortal from "./Preview/components/FramePortal";
import RenderTree from "./Preview/components/RenderTree";
import _ from "lodash";
import { TreeContext } from "pages/Editor";

export default function Preview() {
  const ref = useRef();
  const { tree, subscribe, publish, pages } = useContext(TreeContext);
  // issue #6
  const stylesheets = _.get(pages, "stylesheets", []);
  const scripts = _.get(pages, "scripts", []);
  const treeApi = {
    tree,
    context: "render",
    editable: false,
    subscribe,
    publish,
    iframe: ref,
    pages,
  };
  return (
    <div className="pw">
      <TreeContext.Provider value={treeApi}>
        <FramePortal {...{ ref }} style={{ height: "100%", width: "100%" }}>
          {[
            <Fragment key="0">
              {stylesheets.map((href, key) => (
                <link {...{ href, key }} rel="stylesheet" type="text/css" />
              ))}
              <link href="/iframe.css" rel="stylesheet" type="text/css" />
            </Fragment>,
            <Fragment key="1">
              <RenderTree {...{ tree }} />
              {scripts.map((src, key) => (
                <script {...{ src, key }} type="text/javascript" />
              ))}
            </Fragment>,
          ]}
        </FramePortal>
      </TreeContext.Provider>
    </div>
  );
}
